import React, { useMemo } from "react";
import UniversalTableDatasetButtonComponent from "./UniversalTableDatasetButtonComponent";
import UniversalTableDatasetButtonWrapper from "./UniversalTableDatasetButtonWrapper";
import { DatasetButtonProps } from "./UniversalDatasetTableTypes";

const DatasetButton = ({
  dataset,
  columnIndex,
  rowData,
  compactMode,
  maxAge,
  isExpired,
}: DatasetButtonProps) => {
  const datasetData = dataset?.data?.length ? dataset.data[0] : null;
  const datasetTime = useMemo(
    () => (datasetData?.key ? new Date(datasetData.key as string) : null),
    [datasetData]
  );
  const datasetId = useMemo(
    () =>
      dataset
        ? `dataset-label-${dataset.identifier.split(":")[1]}-${dataset.identifier.split(":")[0]}`
        : null,
    [dataset]
  );

  const comProps = {
    columnIndex,
    rowData,
    compactMode,
    dataset,
    data: datasetData,
    time: datasetTime!,
  };

  return (
    <>
      {isExpired && (
        <UniversalTableDatasetButtonComponent
          {...comProps}
          id={datasetId ?? ""}
          isExpired={isExpired}
        />
      )}
      {!isExpired && (
        <UniversalTableDatasetButtonWrapper
          {...comProps}
          datasetId={datasetId ?? ""}
          maxAge={maxAge}
        />
      )}
    </>
  );
};

export default DatasetButton;
